const SectionLabel = ({ sectionLabel }: { sectionLabel: string }) => {
  return (
    <div
      className="relative drop-shadow-sm squircle squircle-fill-[white] h-8 squircle-radius-[8px] flex items-center px-3 
        before:absolute before:inset-0 before:squircle before:squircle-radius-[8px] before:squircle-outline-[1px] 
        before:squircle-outline-color-border-gray before:pointer-events-none"
    >
      <span className="text-brand-primary-new text-[11px] font-medium leading-none tracking-[0.24px]">
        {sectionLabel.split(" ")?.[0]}
      </span>
      <span className="text-[#67749B] text-[11px] font-normal leading-none tracking-[0.24px] ml-1">
        {sectionLabel.split(" ")?.slice(1).join(" ")}
      </span>
    </div>
  );
};

export default SectionLabel;
